module.exports = __webpack_public_path__ + "img/banner2.e8b28ed4.png";